'use strict';

define('features/vehicle-info/vehicle-info-build',[
  'jquery',
  'lib/transforms/tools.dcr.ctas',
  'lib/page-cache',
  'features/ctas/index',
  'txt!./vehicle.build.hbs',
  'txt!tmpl/ctas.hbs',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/scroller',

  // side effect includes
  'lib/transforms/series.mapByCode',
  'Handlebars',
  'lib/helpers/ifCond',
  'lib/helpers/if_eq',
  'lib/helpers/toJSON',
], function (
  $,
  ctaXform,
  PageCache,
  ctas,
  txtBuild,
  txtCtas,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  scroller
) {
  var __tmplBuild = Handlebars.compile(txtBuild);
  var __tmplCtas = Handlebars.compile(txtCtas);

  var viBuild = {
    // invoked from within vehicle-info-bottom XSL
    // TODO: move outta here
    init: function (el, config) {
      var self = this;
      var $scope = $(el);
      self.$scope = $scope;
      self.config = config;

      // Hide build your vehicle section for Mirai
      if (config.series === 'mirai') {
        return;
      }

      Handlebars.registerPartial('ctasBuild', __tmplCtas({
        ctas: ctaXform(config.ctas)
      }));

      PageCache.await('series.map')
        .then(function (seriesMap) {
          self.drawBuild(seriesMap);
        })
        .catch(function (err) { console.log('Err: ', err); }); // eslint-disable-line no-console
    },

    drawBuild: function (seriesMap) {
      var config = this.config;
      var $scope = this.$scope;
      var lang = config.i18n.lang;

      var ctx = {
        lang: lang,
        title: lang === 'es' ? 'Personaliza tu' : 'Build Your',
        series: config.series,
        seriesSanitized: seriesMap[config.series].series_display_name,
        year: config.seriesYear,
        dealBuilder: config.i18n.dealBuilder
      };
      console.log('CTX for VI Build: ', ctx); // eslint-disable-line no-console

      $scope.html(__tmplBuild(ctx));
      this.analytics();

      // TODO: account for the rest of the CTA pssibilities
      ctas.compare(config.seriesYear, config.series, $scope);
      ctas.inventory({
        series: config.series,
        year: config.seriesYear
      }, $scope);
      ctas.offers(config.series, $scope);
      ctas.dealerSite($scope);
      ctas.dealBuilder(config.seriesYear, config.series, $scope);
    },

    analytics: function () {
      var config = this.config;
      var $scope = this.$scope;

      anAddContext(
        $scope,
        blocks.sectionBlock('Build'),
        blocks.seriesBlock({
          series_code: config.series,
          year: config.seriesYear
        })
      );
      anClicks($scope);
      scroller.add($scope, {
        after: function viewAfter() {
          anPageLoad($scope);
        }
      });
    }
  };

  return viBuild;
});

